import { render, staticRenderFns } from "./CutRing.vue?vue&type=template&id=4f625aa5&"
import script from "./CutRing.vue?vue&type=script&lang=ts&"
export * from "./CutRing.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports